import React, { useEffect, useState } from "react";
import { Outlet } from "react-router";
import SideBar from "../components/Navbar/SideBar";
import Navbar from "../components/Navbar/Navbar";
import BottomNavigation from "../components/Overley/BottomNavigation";

type RootLayoutProps = {
  children: React.ReactNode;
};
const RootLayout = ({ children }: RootLayoutProps) => {
  const [sideBarState, setSideBarState] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClick = (value: boolean) => {
    setOpen(value);
  };

  useEffect(() => {
    handleClick(true);
    setTimeout(() => {
      handleClick(false);
    }, 5000);
  }, []);
  var Scroll = require("react-scroll");
  var scroll = Scroll.animateScroll;
  return (
    <>
      <SideBar sideBarState={sideBarState} setSideBarState={setSideBarState} />
      <div className="h-screen w-screen  flex flex-col">
        <Navbar sideBarState={sideBarState} setSideBarState={setSideBarState} />
        <div className="h-full overflow-y-auto ">
          <Outlet />
        </div>
        <BottomNavigation />
      </div>
    </>
  );
};

export default RootLayout;
